'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { BROWSER_ICON_URL, SITE } from './constants';
import './[locale]/globals.css';

// 定义错误信息
const ERROR_MESSAGES = {
  zh: {
    title: '系统错误',
    description: '我们已记录此错误并将尽快修复',
    retry: '刷新',
  },
  en: {
    title: 'System Error',
    description: 'We have recorded this error and will fix it soon',
    retry: 'Refresh',
  },
} as const;

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // 向 Sentry 报告错误
    Sentry.withScope((scope) => {
      scope.setLevel('fatal'); // 设置为最高级别
      scope.setTag('errorType', 'globalError');
      Sentry.captureException(error);
    });
  }, [error]);

  // 根据站点选择语言
  const lang = SITE === 'china' ? 'zh' : 'en';
  const messages = ERROR_MESSAGES[lang];

  return (
    <html lang={lang}>
      <head>
        <title>{messages.title}</title>
        <link rel="icon" href={BROWSER_ICON_URL} />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" type="image/png" />
        <meta name="robots" content="noindex, nofollow" />
      </head>
      <body className="font-ShengShu">
        <div className="flex min-h-screen w-full flex-col items-center justify-center bg-white">
          <h2 className="font-semibold text-2xl text-black">{messages.title}</h2>
          <p className="mt-2 text-black">{messages.description}</p>
          <button
            type="button"
            onClick={() => {
              window.location.reload();
            }}
            className="mt-4 rounded-md bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
          >
            {messages.retry}
          </button>
        </div>
      </body>
    </html>
  );
}
